import { Component, type ErrorInfo, type ReactNode } from 'react';

import { handleError } from '@/utils/errorUtils';

interface Props {
  children: ReactNode;
  message: string;
  surface: string;
}

interface State {
  hasError: boolean;
}

export class A2uiErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    handleError(
      error,
      { extra: { componentStack: info.componentStack } },
      this.props.surface
    );
  }

  render() {
    if (this.state.hasError) {
      return <p className={'text-sm'}>{this.props.message}</p>;
    }

    return this.props.children;
  }
}
